

































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component
export default class ModalSolicitacaoTipoLesaoQuantidade extends Vue {
  quantidade: number = 1

  $refs!: {
    quantidadeForm: any,
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [
      v => !!v || 'Campo obrigatório.',
      v => (v && v <= 10) || 'Quantidade máxima permitida é 10.',
    ],
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getShowModalTipoLesaoQuantidade() {
    return this.getSolicitacaoStore.modal.showTipoLesaoQuantidade
  }

  get getLesaoSelecionada() {
    return this.getSolicitacaoStore.tipoLesaoQuantidade
  }

  confirmar() {
    if (this.$refs.quantidadeForm.validate()) {
      this.$emit('addSelectedLesaoQuantidade', {
        ...this.getLesaoSelecionada,
        quantidade: this.quantidade,
      })
      this.getSolicitacaoStore.setModal({ name: 'showTipoLesaoQuantidade', value: false })
      this.quantidade = 1
      this.$refs.quantidadeForm.reset()
      this.$refs.quantidadeForm.resetValidation()
    }
  }
}
